import { Component } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { CommonQuestionTailleComponent } from '@kv-common-components/kv-common-components';
import { CacheService } from '@kv-common-components/kx-services';
@Component({
    selector: 'app-question-taille-component',
    templateUrl: './question-taille.component.html',
    styleUrls: ['./question-taille.component.scss'],
})
export class QuestionTailleComponent extends CommonQuestionTailleComponent {
    constructor(
        protected logger: NGXLogger,
        protected cacheService: CacheService
    ) {
        super(logger, cacheService);
    }
}
